import React from "react";

// components

import CardAccount from "../../Cards/CardAccount";

export default function Account() {
  return (
    <>
      <div className="flex justify-center mb-10">
        <div className="w-full lg:w-8/12 px-4 py-16">
          <CardAccount />
        </div>
      </div>
    </>
  );
}
